export default {
    namespaced: true,
    state:{
        modalOpened: false,
    },
    mutations:{
        closeModal:(s)=>{
            s.modalOpened = false;
        },
        openModal:(s)=>{
            s.modalOpened = true;
        },
    },

}